import { random } from 'lodash';

export const BarChartDataMock: any = Array.from(Array(34), (_) => random(1, 100));
